import type { TimeSlot } from "@features/reservation/model/types";

/** "HH:mm" → 분 단위. 시작 시간용 (00:00 = 0분) */
export function parseStartTimeToMinutes(time: string): number {
  const [h, m] = time.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

/** "HH:mm" → 분 단위. 종료 시간용 (00:00만 24:00 = 1440분, 00:30 등은 0시 30분) */
export function parseEndTimeToMinutes(time: string): number {
  const [h, m] = time.split(":").map(Number);
  const hours = h === 0 && (m ?? 0) === 0 ? 24 : (h ?? 0);
  return hours * 60 + (m ?? 0);
}

/** 시작·종료 시간 차이를 시간 단위로 반환 (절대값) */
export function getDurationHours(startTime: string, endTime: string): number {
  if (!startTime || !endTime) return 0;
  const startMin = parseStartTimeToMinutes(startTime);
  const endMin = parseEndTimeToMinutes(endTime);
  return Math.abs(endMin - startMin) / 60;
}

/** "HH:mm" 문자열을 TimeSlot으로 변환 */
export function parseTimeToSlot(time: string): TimeSlot {
  const [hStr, mStr] = time.split(":");
  const h = Number.parseInt(hStr ?? "0", 10);
  const m = Number.parseInt(mStr ?? "0", 10);
  const hour12 = h > 12 ? h - 12 : h;
  const ampm = h < 12 ? "AM" : "PM";
  const label = `${hour12}:${m.toString().padStart(2, "0")} ${ampm}`;
  return { value: time, label };
}

/** 30분 단위 타임슬롯 생성 (00:00 ~ 23:30) */
export function createTimeSlots(): TimeSlot[] {
  const slots: TimeSlot[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const value = `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
      const hour12 = h > 12 ? h - 12 : h;
      const ampm = h < 12 ? "AM" : "PM";
      const label = `${hour12}:${m.toString().padStart(2, "0")} ${ampm}`;
      slots.push({ value, label });
    }
  }
  return slots;
}
